<bx-erb-error-banner></bx-erb-error-banner>
<bx-web-pic-in-pic></bx-web-pic-in-pic>
<router-outlet></router-outlet>
